import Vue from 'vue';
import { Pluralize } from '@/lib/services/Utils';

Vue.filter('pluralize', (count: number, word: string | null, wordPlural: string | null) => {
    return Pluralize(count, word, wordPlural);
});